import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';

import InsuranceCarriersList_v01 from '../InsuranceCarriersList_v02';

const AboutLegacyInsurance_v03: React.FC = () => {
  return (
    <Container className="my-5">
      {/* Intro section with image */}
      <Row className="align-items-center mb-5">
        <Col md={6}>
          <h1>Legacy Insurance Network</h1>
          <p className="lead">
            <strong>
              Protecting Futures <br></br>
              Honoring Legacies
            </strong>
          </p>
          <p>
              For over 30 years, our team, has been focused on helping individuals, families, and businesses find the right coverage
              to  protect what matters most: your family, your business and your future. 
              
              Whether you’re looking for auto, home, life, or commercial insurance, 
              we’re here to provide personalized service, and honest advice to help you find the strategies and coverage that will protect what matters most.
              
            
          </p>
        </Col>
        <Col md={6}>
          <Image
            src="./insurance/images/businessInsurance/OfficeBuilding01.jpg" // Replace with your preferred building image URL
            alt="Legacy Insurance Network Office building "
            fluid
            rounded
          />
        </Col>
      </Row>



      <hr className="my-5"></hr>

        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <i className="bi bi-shield-check" style={{ fontSize: '2rem' }}></i>
            <h5 className="mt-2">Trusted Protection</h5>
            <p>We partner with top-rated carriers to ensure you get the best coverage at the best value.  Below is a short list of carriers that we work with on a regular basis. However, their are many more in our network to help us cover special situations.</p>
          </div>
          <div className="col-md-4 mb-4">
            <i className="bi bi-people-fill" style={{ fontSize: '2rem' }}></i>
            <h5 className="mt-2">Client-First Approach</h5>
            <p>Your needs come first. We take the time to understand your situation and find the coverage that best fits your needs.</p>
          </div>
          <div className="col-md-4 mb-4">
            <i className="bi bi-stars" style={{ fontSize: '2rem' }}></i>
            <h5 className="mt-2">Local Expertise</h5>
            <p>We’re proud to serve our community and we are always working to stay current with the unique local risks and regulations including 
              community-specific needs, specific regulatory requirements, relationships with local contractors, legal teams, and adjusters
            </p>

          </div>
        </div>



      <InsuranceCarriersList_v01></InsuranceCarriersList_v01>

    </Container>
  );
};

export default AboutLegacyInsurance_v03;
